var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<formly-form model=\"vm.fee\" fields=\"vm.fields\"></formly-form>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/admin/gameDevelopers/feeForm.jade
 ** module id = 625
 ** module chunks = 0
 **/